import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./interfaces";
import { Actions } from "./styles";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";
import AddNewDocument from "../../../AddNewDocument/AddNewDocument";

const DocTypeActions = ({
  handleNotifyTable,
  documentFieldsProps,
  askAction,
  askHide = false,
  askVerified = false,
}: Props) => {
  const { t } = useTranslation();

  const [closePopover, setClosePopover] = useState<boolean>(false);

  const handleNotify = () => {
    setClosePopover(true);
    // close pop-over then notify the parent page
    handleNotifyTable();
    setClosePopover(false);
  };

  const markAllVerified = () => {
    if (askAction) {
      setClosePopover(true);
      askAction("markAllVerified");
    }
  };

  const hideLine = () => {
    if (askAction) {
      setClosePopover(true);
      askAction("hideLine");
    }
  };

  return (
    <SimplePopover
      buttonType="icon"
      buttonContent={<FontAwesomeIcon icon={faEllipsisV} />}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      shouldClose={closePopover}
    >
      <Actions>
        <AddNewDocument
          openButtonKey={`${t("buttons.add")} ${
            documentFieldsProps?.type ? `"${documentFieldsProps?.type.name}"` : ""
          }`}
          buttonType="text"
          variant="text"
          handleNotifyParent={handleNotify}
          documentFieldsProps={documentFieldsProps}
          allowMarkVerified
          readOnlyFields={{
            isLegalEntityRO: documentFieldsProps?.legalEntity ? true : false,
          }}
        />
        {!!askAction && (askHide || askVerified) && (
          <>
            {askVerified && (
              <Button
                variant="text"
                onClick={markAllVerified}
              >
                {`${t("buttons.mark_all_verified")}`}
              </Button>
            )}
            {askHide && <Button onClick={hideLine}>{`${t("buttons.hide_line")}`}</Button>}
          </>
        )}
      </Actions>
    </SimplePopover>
  );
};

export default DocTypeActions;
